module.exports = __webpack_public_path__ + "img/icon_parking.4292a112.png";